module.exports = __webpack_public_path__ + "static/media/exclamation-circle-solid.8bc7788f.svg";


//////////////////
// WEBPACK FOOTER
// ./src/images/exclamation-circle-solid.svg
// module id = 429
// module chunks = 0